import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNodeTableData = () => {
    return useQuery(QUERY_KEY.GET_NODE_TABLE_DATA, ApiService.nodeTableData, {retry: false})
}

export default useNodeTableData